<template>
  <CCard class="current-month-card mb-4">
    <CCardHeader class="border-0 px-4 pb-1 pt-4">
      <div class="d-flex align-items-center font-weight-medium">
        <CIcon name="cipWallet02" size="custom-size" :width="18" class="mr-2"/>
        <translate translate-context="accounting.refund">This month</translate>
      </div>
    </CCardHeader>
    <CCardBody class="pt-1">
      <PTransparentLoader :loading="isLoading">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <div class="current-month-amount">
              {{ statistics.pending_balance | currency(statistics.currency || 'EUR') }}
            </div>
            <div class="small">
              <translate translate-context="payout.currentMonth">Earnings gained this month</translate>
            </div>
          </div>

          <!-- Toggle espansione -->
          <CButton
            v-if="hasPicaServices"
            color="light"
            size="sm"
            variant="ghost"
            @click="expanded = !expanded"
            class="mt-2"
          >
            <CIcon
              :name="expanded ? 'cipChevronUp' : 'cipChevronDown'"
              size="lg"
            />
          </CButton>
        </div>

        <!-- Dettaglio eventi espandibile -->
        <CCollapse :show="expanded" v-if="hasPicaServices">
          <div class="mt-4">
            <PayoutEventDetail
              :pica-services="statistics.pica_services"
              :currency="statistics.currency || 'EUR'"
              @download="$emit('download-statistics')"
            />
          </div>
        </CCollapse>
      </PTransparentLoader>
    </CCardBody>
  </CCard>
</template>

<script>
import PTransparentLoader from '@/domain/core/components/PTransparentLoader.vue'
import PayoutEventDetail from './PayoutEventDetail.vue'

export default {
  name: 'CurrentMonthCard',
  components: {
    PTransparentLoader,
    PayoutEventDetail
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    hasPicaServices() {
      return this.statistics.pica_services && this.statistics.pica_services.length > 0
    }
  }
}
</script>